import { useAppSelector } from '@store/hooks'
import { selectSelectedUser } from '@store/UserReducer'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { emailRule, requiredRule } from '@utils/rules'
import { Alert, Form, Input } from 'antd'
import { useEffect } from 'react'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedUser())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Form.Item name="firstName" rules={[requiredRule()]} label={'First name'}>
        <Input />
      </Form.Item>
      <Form.Item name="lastName" rules={[requiredRule()]} label={'Last name'}>
        <Input />
      </Form.Item>
      <Form.Item
        name="email"
        rules={[requiredRule(), emailRule()]}
        label={'Email'}
      >
        <Input />
      </Form.Item>
      <Alert
        title="Please note that editing a user profile in the CRM is intended solely to correct inaccurate information. 
        It should not be used to overwrite all data for the purpose of reassigning the profile to a different person.
        These details are visible to the client and are used to log-in on various platforms, so any incorrect changes may lead to confusion or access issues."
        type="error"
        showIcon
      />
    </Form>
  )
}

export default Update
